import { useContext } from 'react';

import { LoaderContext } from '../context/LoaderProvider';

function useLoader() {
    return useContext(LoaderContext);
}

export default useLoader;
